module.exports = __webpack_public_path__ + "Project.911abfe2316548cf6358c7f190ae1810.hashedasset.svg";